export { default as Chip } from './Chip'
export type { ChipProps } from './Chip'
